import { FC, memo } from 'react'
import { NodeProps, Position } from '@xyflow/react'
import { useTranslate } from 'react-admin'
import Typography from '@mui/material/Typography'
import StorageIcon from '@mui/icons-material/Storage'
import BaseNode from './BaseNode'
import { DataNodeData } from '../types'
import { xxllncColor } from '../../../layout/theme/color'

const DataNode: FC<NodeProps> = ({ id, data, selected }) => {
  const translate = useTranslate()
  const nodeData = data as DataNodeData
  const attachmentRole = (nodeData.attachmentRole ?? '').trim()
  const subtitle = attachmentRole
    ? `${attachmentRole} · ${nodeData.format.toUpperCase()} · ${nodeData.selector || 'whole file'}`
    : translate('workflow.node.missingAttachmentRoleSubtitle')

  return (
    <BaseNode
      nodeType="data"
      icon={<StorageIcon fontSize="small" />}
      label={nodeData.label}
      nodeId={id}
      subtitle={subtitle}
      selected={selected}
      handles={[
        { type: 'target', position: Position.Top },
        { type: 'source', position: Position.Bottom },
      ]}
    >
      {!attachmentRole && (
        <Typography
          variant="caption"
          sx={{
            color: xxllncColor.orange100,
            fontWeight: 600,
            display: 'block',
            lineHeight: 1.35,
          }}
        >
          {translate('workflow.node.missingAttachmentRoleWarning')}
        </Typography>
      )}
    </BaseNode>
  )
}

export default memo(DataNode)
